// extracted by mini-css-extract-plugin
export default {"chat_input":"chat-input_chat_input__BqK9Z","chat_actions":"chat-input_chat_actions__A00dT"};